export default ({ title }) => {
  if (title) {
    return title;
  }
};
